import { render, staticRenderFns } from "./EditInventoryDetails.vue?vue&type=template&id=71041027&scoped=true"
import script from "./EditInventoryDetails.vue?vue&type=script&lang=js"
export * from "./EditInventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./EditInventoryDetails.vue?vue&type=style&index=0&id=71041027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71041027",
  null
  
)

export default component.exports